/** @jsx jsx */
import { jsx } from "@emotion/core";
import { useState, useRef } from "react";
import * as style from "./ImageCodeStyle";
import { containerCommon, inputBoxCommon, btnCommon } from "./indexStyle";
import { useEffectOnce } from "../Effect/useEffectOnce";
export function ImageCode(props) {
    const [src, setSrc] = useState(props.initSrc);
    const [code, setCode] = useState("");
    const input = useRef(null);
    const change = (event) => {
        setCode(event.target.value);
    };
    const confirm = () => {
        typeof props.onConfirm === "function" && props.onConfirm(code);
    };
    const cancel = () => {
        typeof props.onCancel === "function" && props.onCancel();
    };
    const refreshCode = () => {
        let current = src.replace(/\?*$/, "");
        if (/\?/.test(current)) {
            setSrc(current + `&__c=${Date.now()}`);
        }
        else {
            setSrc(current + `?__c=${Date.now()}`);
        }
    };
    /**
     * 修复safari键盘无法收回的bug
     */
    useEffectOnce(() => {
        let hasFocus = false;
        const focusin = (event) => {
            if (event.target === input.current) {
                hasFocus = true;
            }
        };
        const focusout = (event) => {
            if (hasFocus) {
                hasFocus = false;
                window.setTimeout(() => {
                    window.scroll(0, 0);
                }, 100);
            }
        };
        document.body.addEventListener("focusin", focusin);
        document.body.addEventListener("focusout", focusout);
        return () => {
            document.body.removeEventListener("focusin", focusin);
            document.body.removeEventListener("focusout", focusout);
        };
    });
    return (jsx("div", { css: [containerCommon, style.icContainer] },
        jsx("div", { css: style.icBox },
            jsx("div", { css: style.icImg, onClick: refreshCode },
                jsx("img", { src: src, alt: "" }),
                jsx("p", null,
                    jsx("svg", { viewBox: "0 0 24 24" },
                        jsx("path", { d: "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" })),
                    "\u70B9\u51FB\u56FE\u7247\u5373\u53EF\u5237\u65B0\u9A8C\u8BC1\u7801")),
            jsx("div", { css: [style.icCode, inputBoxCommon] },
                jsx("input", { type: "text", value: code, maxLength: 4, placeholder: "\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801", onChange: change, ref: input })),
            jsx("div", { css: [btnCommon, style.icBtn] },
                jsx("div", { className: "cancel", onClick: cancel }, "\u53D6\u6D88"),
                jsx("div", { className: "confirm", onClick: confirm }, "\u786E\u5B9A")))));
}
